import { Badge } from './badges';
import { splitClozeSegments } from './clozeText';
import type { ExerciseQuestionView } from '../../../api/content.types';

function ClozePrompt({ prompt }: { prompt: string }) {
  return (
    <span style={{ fontFamily: 'var(--font-jp)', fontSize: 16, lineHeight: 1.8, color: 'var(--ink)' }}>
      {splitClozeSegments(prompt).map((seg, i) =>
        seg.kind === 'blank' ? (
          <span key={i} aria-label="chỗ trống" style={{ fontWeight: 700, color: 'var(--cta-default)', background: 'rgba(0,91,150,0.16)', borderRadius: 3 }}>
            {seg.text}
          </span>
        ) : (
          <span key={i}>{seg.text}</span>
        ),
      )}
    </span>
  );
}

/** CLOZE dùng dữ liệu THẬT nhưng API không có đáp án đúng tách riêng — chỉ trình bày, không chấm điểm. */
export function ClozeExercise({ instruction, example, questions }: { instruction: string | null; example: string | null; questions: ExerciseQuestionView[] }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
        <Badge tone="info">Điền từ</Badge>
        <Badge tone="neutral">Chỉ để đọc — không chấm điểm</Badge>
      </div>
      {instruction && <h2 style={{ fontSize: 19, fontWeight: 600, color: 'var(--ink)', margin: 0 }}>{instruction}</h2>}
      {example && (
        <div style={{ background: 'var(--surface-section)', borderRadius: 'var(--radius-card)', padding: 16 }}>
          <div style={{ fontSize: 11.5, fontWeight: 700, color: 'var(--text-secondary)', letterSpacing: 0.4, marginBottom: 4 }}>VÍ DỤ</div>
          <ClozePrompt prompt={example} />
        </div>
      )}
      {questions.length === 0 ? (
        <div style={{ fontSize: 14, color: 'var(--text-secondary)' }}>Nhóm bài tập này chưa có câu nào.</div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {questions.map((q) => (
            <div key={q.order} style={{ border: '1px solid var(--border-default)', borderRadius: 'var(--radius-card)', padding: 16 }}>
              <div
                style={{
                  width: 22,
                  height: 22,
                  borderRadius: '50%',
                  background: 'rgba(0,91,150,0.09)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: 11.5,
                  fontWeight: 700,
                  color: 'var(--cta-default)',
                  marginBottom: 8,
                }}
              >
                {q.order}
              </div>
              <ClozePrompt prompt={q.prompt} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
